import { NgModule } from '@angular/core';
import * as _ from "underscore";
import { EditorComponent } from './editor/editor.component';
import { ToolboxComponent } from './toolbox/toolbox.component';
import { PropertyWindowComponent } from './property-window/property-window.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { EditorCanvasComponent } from './editor-canvas/editor-canvas.component';
import { AdvancedPropertyModule } from './advanced-property-window/advanced-property.module';
import { ToolboxItemComponent } from './toolbox/toolbox-item/toolbox-item.component';
import { LoginComponent } from './login/login.component';
import { NavbarComponent } from './navbar/navbar.component';
import { ProjectComponent } from './project/project.component';
import { ProjectListComponent } from './project/project-list/project-list.component';
import { ProjectEditComponent } from './project/project-edit/project-edit.component';
import { VariantComponent } from './variant/variant.component';
import { VariantListComponent } from './variant/variant-list/variant-list.component';
import { WagonViewComponent } from './wagon/wagon.component';
import { WagonViewListComponent } from './wagon/wagon-list/wagon-list.component';
import { WagonViewEditComponent } from './wagon/wagon-edit/wagon-edit.component';
import { SimpleInputDialog } from './Modal/simple-input.modal';
import { WagonClassCreationComponent } from './wagon/wagon-edit/wagon-class-creation/wagon-class-creation.component';
import { ApplicationPipesModule } from './pipes/applicationpipes.module';
import { EvaluationComponent } from './evaluation/evaluation.component';
import { WagonClassPresentationComponent } from './wagon/wagon-edit/wagon-class-presentation/wagon-class-presentation.component';
import { CompanyEditComponent } from './company/company-edit/company-edit.component';
import { CompanyComponent } from './company/company.component';
import { CompanyListComponent } from './company/company-list/company-list.component';
import { ModalWithMessageLoop } from './Modal/modalWithMessageLoop';
import { DatamanagementComponent } from './datamanagement/datamanagement.component';
import { DatamanagementListComponent } from './datamanagement/datamanagement-list/datamanagement-list.component';
import { DatamanagementDetailsComponent } from './datamanagement/datamanagement-details/datamanagement-details.component';
import { AgeGenderComponent } from './matrix-component/age-gender/age-gender.component';
import { AgeGenderDialog } from './Modal/ageGender.modal';
import { GridListComponent } from './matrix-component/grid-list/grid-list.component';
import { CellComponent } from './matrix-component/grid-list/cell/cell.component';
import { TransportDefaultsComponent } from './datamanagement/datamanagement-details/transport-defaults/transport-defaults.component';
import { TravelmixComponent } from './datamanagement/datamanagement-details/travelmix/travelmix.component';
import { LuggageAmountWindowComponent } from './datamanagement/datamanagement-details/travelmix/luggage-amount-window/luggage-amount-window.component';
import { AgeGenderDistributionComponent } from './datamanagement/datamanagement-details/age-gender-distribution/age-gender-distribution.component';
import { AgeGenderLuggageFactorComponent } from './datamanagement/datamanagement-details/age-gender-luggage-factor/age-gender-luggage-factor.component';
import { LuggageSizeComponent } from './datamanagement/datamanagement-details/luggage-size/luggage-size.component';
import { StorageAcceptanceComponent } from './datamanagement/datamanagement-details/storage-acceptance/storage-acceptance.component';
import { AgeGenderStorageFactorComponent } from './datamanagement/datamanagement-details/age-gender-storage-factor/age-gender-storage-factor.component';
import { UsermanagementComponent } from './usermanagement/usermanagement.component';
import { UsermanagementListComponent } from './usermanagement/usermanagement-list/usermanagement-list.component';
import { UsermanagementListAddUserComponent } from './usermanagement/usermanagement-list/usermanagement-list-add-user/usermanagement-list-add-user.component';
import { UsermanagementListOverridePasswordComponent } from './usermanagement/usermanagement-list/usermanagement-list-override-password/usermanagement-list-override-password.component';
import { SettingsComponent } from './settings/settings.component';
import { FileImportDialogComponent } from './datamanagement/datamanagement-list/file-import-dialog/file-import-dialog.component';
import { AgeGenderAdaptationComponent } from './datamanagement/datamanagement-details/age-gender-adaptation/age-gender-adaptation.component';
import { PassengerChangeTimeVectorComponent } from './datamanagement/datamanagement-details/passenger-change-time-vector/passenger-change-time-vector.component';
import { DoorWidthReductionComponent } from './datamanagement/datamanagement-details/door-width-reduction/door-width-reduction.component';
import { BaseValueTimeComponent } from './datamanagement/datamanagement-details/base-value-time/base-value-time.component';
import { BaseFactorComponent } from './datamanagement/datamanagement-details/base-factor/base-factor.component';
import { PolynomialFactorComponent } from './datamanagement/datamanagement-details/polynomial-factor/polynomial-factor.component';
import { AisleWidthComponent } from './datamanagement/datamanagement-details/aisle-width/aisle-width.component';
import { AlternativeRoomsComponent } from './datamanagement/datamanagement-details/alternative-rooms/alternative-rooms.component';
import { AccessibilityOfTheSeatsFactorComponent } from './datamanagement/datamanagement-details/accessibility-of-the-seats-factor/accessibility-of-the-seats-factor.component';
import { AmountOfNotStorableBaggageComponent } from './datamanagement/datamanagement-details/amount-of-not-storable-baggage/amount-of-not-storable-baggage.component';
import { SimplicityLuggageAccommodationFactorComponent } from './datamanagement/datamanagement-details/simplicity-luggage-accommodation-factor/simplicity-luggage-accommodation-factor.component';
import { LuggageRacksWhenBoardingComponent } from './datamanagement/datamanagement-details/luggage-racks-when-boarding/luggage-racks-when-boarding.component';
import { BaggageAccumulationComponent } from './datamanagement/datamanagement-details/baggage-accumulation/baggage-accumulation.component';
import { ReservationObligationComponent } from './datamanagement/datamanagement-details/reservation-obligation/reservation-obligation.component';
import { CompartmentsAvailableComponent } from './datamanagement/datamanagement-details/compartments-available/compartments-available.component';
import { SeatsPerRunningMeterFactorComponent } from './datamanagement/datamanagement-details/seats-per-running-meter-factor/seats-per-running-meter-factor.component';
import { AgeDistributionComponent } from './datamanagement/datamanagement-details/age-distribution/age-distribution.component';
import { AgeGenderAdaptationStepsComponent } from './datamanagement/datamanagement-details/age-gender-adaptation-steps/age-gender-adaptation-steps.component';
import { PassengerChangeTimeVectorStepsComponent } from './datamanagement/datamanagement-details/passenger-change-time-vector-steps/passenger-change-time-vector-steps.component';
import { StepsWidthFactorComponent } from './datamanagement/datamanagement-details/steps-width-factor/steps-width-factor.component';
import { BoardingPlaceDensityOfPeopleFactorComponent } from './datamanagement/datamanagement-details/boarding-place-density-of-people-factor/boarding-place-density-of-people-factor.component';
import { LocationWaysFactorComponent } from './datamanagement/datamanagement-details/location-ways-factor/location-ways-factor.component';
import { DoorWidthAndPhysicalSeparationFactorComponent } from './datamanagement/datamanagement-details/door-width-and-physical-separation-factor/door-width-and-physical-separation-factor.component';
import { ApplicationDirectivesModule } from './directives/applicationdirectives.module';
import { MultiPurposeAreaViewComponent } from './advanced-property-window/multipurposearea/multipurposearea.component';
import { AgeGenderCompareDialog } from './Modal/ageGenderCompare.model';
import { UsermanagementListChangeEmailComponent } from './usermanagement/usermanagement-list/usermanagement-list-change-email/usermanagement-list-change-email.component';
import { SpecialFactorsComponent } from './datamanagement/datamanagement-details/special-factors/special-factors.component';
import { ModalOverrideInput } from './Modal/modalOverrideInput.modal';
import { LoaderComponentComponent } from './loader-component/loader-component.component';
import { AddVariantComponent } from './variant/variant-list/add-variant/add-variant.component';
import { MatButtonModule } from '@angular/material/button'
import { MatCheckboxModule } from '@angular/material/checkbox'
import { MatToolbarModule } from '@angular/material/toolbar'
import { MatMenuModule } from '@angular/material/menu'
import { MatSelectModule } from '@angular/material/select'
import { MatInputModule } from '@angular/material/input'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatCardModule } from '@angular/material/card'
import { MatListModule } from '@angular/material/list'
import { MatIconModule } from '@angular/material/icon'
import { MatTableModule } from '@angular/material/table'
import { MatRadioModule } from '@angular/material/radio'
import { MatExpansionModule } from '@angular/material/expansion'
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner'
import { MatSidenavModule } from '@angular/material/sidenav'
import {MatSliderModule} from '@angular/material/slider';
import { MatDialogModule } from '@angular/material/dialog'
import { MatButtonToggleModule } from '@angular/material/button-toggle'
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import { MatTabsModule } from '@angular/material/tabs'
import { MatGridListModule } from '@angular/material/grid-list'
import { MatTooltipModule } from '@angular/material/tooltip'
import { MatChipsModule } from '@angular/material/chips'
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TrainComponent } from './train/train.component';
import { TrainConfigurationComponent } from './train/train-configuration/train-configuration.component';
import { TrainListViewComponent } from './train/train-list-view/train-list-view.component';
import { TrainWagonComponent } from './train/train-configuration/train-wagon/train-wagon.component';
import { AddWagonVariantComponent } from './train/add-wagon-variant/add-wagon-variant.component';
import { EvaluationSelectionComponent } from './evaluation/evaluation-selection/evaluation-selection.component';
import { EvaluationTrainComponent } from './evaluation/evaluation-train/evaluation-train.component';
import { EvaluationVariantComponent } from './evaluation/evaluation-variant/evaluation-variant.component';
import { EvaluationAdvanceSettingsComponent } from './evaluation/evaluation-advanced-settings/evaluation-advanced-settings.component';
import { EvaluationTravelMixesComponent } from './evaluation/evaluation-travel-mixes/evaluation-travel-mixes.component';
import { ContainerVisibilityWindowComponent } from './container-visibility-window/container-visibility-window.component';
import { MeasurementControlWindowComponent } from './measurement-control-window/measurement-control-window.component';
import { EvaluationGraphicsComponent } from './evaluation/evaluation-graphics/evaluation-graphics.component';

@NgModule({
  declarations: [
    NavbarComponent,
    EditorComponent,
    ToolboxComponent,
    PropertyWindowComponent,
    EditorCanvasComponent,
    ToolboxItemComponent,
    LoginComponent,
    ProjectComponent,
    ProjectListComponent,
    ProjectEditComponent,
    WagonViewComponent,
    WagonViewListComponent,
    WagonViewEditComponent,
    VariantComponent,
    VariantListComponent,
    SimpleInputDialog,
    WagonClassCreationComponent,
    WagonClassPresentationComponent,
    CompanyEditComponent,
    CompanyComponent,
    CompanyListComponent,
    ModalWithMessageLoop,
    DatamanagementComponent,
    DatamanagementListComponent,
    DatamanagementDetailsComponent,
    AgeGenderComponent,
    AgeGenderDialog,
    ModalOverrideInput,
    GridListComponent,
    CellComponent,
    TransportDefaultsComponent,
    TravelmixComponent,
    LuggageAmountWindowComponent,
    AgeGenderDistributionComponent,
    AgeGenderLuggageFactorComponent,
    LuggageSizeComponent,
    StorageAcceptanceComponent,
    AgeGenderStorageFactorComponent,
    UsermanagementComponent,
    UsermanagementListComponent,
    UsermanagementListAddUserComponent,
    UsermanagementListOverridePasswordComponent,
    SettingsComponent,
    FileImportDialogComponent,
    AgeGenderAdaptationComponent,
    PassengerChangeTimeVectorComponent,
    DoorWidthReductionComponent,
    BaseValueTimeComponent,
    BaseFactorComponent,
    PolynomialFactorComponent,
    AisleWidthComponent,
    AlternativeRoomsComponent,
    AccessibilityOfTheSeatsFactorComponent,
    AmountOfNotStorableBaggageComponent,
    SimplicityLuggageAccommodationFactorComponent,
    LuggageRacksWhenBoardingComponent,
    BaggageAccumulationComponent,
    ReservationObligationComponent,
    CompartmentsAvailableComponent,
    SeatsPerRunningMeterFactorComponent,
    AgeDistributionComponent,
    AgeGenderAdaptationStepsComponent,
    PassengerChangeTimeVectorStepsComponent,
    StepsWidthFactorComponent,
    BoardingPlaceDensityOfPeopleFactorComponent,
    LocationWaysFactorComponent,
    DoorWidthAndPhysicalSeparationFactorComponent,
    MultiPurposeAreaViewComponent,
    AgeGenderCompareDialog,
    UsermanagementListChangeEmailComponent,
    SpecialFactorsComponent,
    LoaderComponentComponent,
    AddVariantComponent,
    TrainComponent,
    TrainConfigurationComponent,
    TrainListViewComponent,
    TrainWagonComponent,
    AddWagonVariantComponent,
    EvaluationComponent,
    EvaluationSelectionComponent,
    EvaluationTrainComponent,
    EvaluationVariantComponent,
    EvaluationAdvanceSettingsComponent,
    EvaluationTravelMixesComponent,
    EvaluationGraphicsComponent,
    ContainerVisibilityWindowComponent,
    MeasurementControlWindowComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    MatButtonModule,
    MatCheckboxModule,
    MatToolbarModule,
    MatMenuModule,
    MatSelectModule,
    MatInputModule,
    MatFormFieldModule,
    MatCheckboxModule,
    MatCardModule,
    MatListModule,
    MatIconModule,
    MatTableModule,
    MatRadioModule,
    MatProgressSpinnerModule,
    MatExpansionModule,
    FormsModule,
    ReactiveFormsModule,
    AdvancedPropertyModule,
    MatSidenavModule,
    MatDialogModule,
    MatButtonToggleModule,
    ApplicationPipesModule.forRoot(),
    ApplicationDirectivesModule.forRoot(),
    MatTabsModule,
    MatGridListModule,
    MatTooltipModule,
    MatChipsModule,
    MatSlideToggleModule,
    MatSliderModule
  ],
  exports: [
    NavbarComponent,
    EditorComponent,
    ToolboxComponent,
    PropertyWindowComponent,
    EditorCanvasComponent,
    ToolboxItemComponent,
    LoginComponent,
    ProjectComponent,
    ProjectListComponent,
    ProjectEditComponent,
    WagonViewComponent,
    WagonViewListComponent,
    WagonViewEditComponent,
    VariantComponent,
    VariantListComponent,
    SimpleInputDialog,
    WagonClassCreationComponent,
    EvaluationComponent,
    WagonClassPresentationComponent,
    CompanyEditComponent,
    CompanyComponent,
    CompanyListComponent,
    ModalWithMessageLoop,
    DatamanagementComponent,
    DatamanagementListComponent,
    DatamanagementDetailsComponent,
    AgeGenderComponent,
    AgeGenderDialog,
    ModalOverrideInput,
    GridListComponent,
    CellComponent,
    TransportDefaultsComponent,
    TravelmixComponent,
    LuggageAmountWindowComponent,
    AgeGenderDistributionComponent,
    AgeGenderLuggageFactorComponent,
    LuggageSizeComponent,
    StorageAcceptanceComponent,
    AgeGenderStorageFactorComponent,
    UsermanagementComponent,
    UsermanagementListComponent,
    UsermanagementListAddUserComponent,
    UsermanagementListOverridePasswordComponent,
    SettingsComponent,
    FileImportDialogComponent,
    AgeGenderAdaptationComponent,
    PassengerChangeTimeVectorComponent,
    DoorWidthReductionComponent,
    BaseValueTimeComponent,
    BaseFactorComponent,
    PolynomialFactorComponent,
    AisleWidthComponent,
    AlternativeRoomsComponent,
    AccessibilityOfTheSeatsFactorComponent,
    AmountOfNotStorableBaggageComponent,
    SimplicityLuggageAccommodationFactorComponent,
    LuggageRacksWhenBoardingComponent,
    BaggageAccumulationComponent,
    ReservationObligationComponent,
    CompartmentsAvailableComponent,
    SeatsPerRunningMeterFactorComponent,
    AgeDistributionComponent,
    AgeGenderAdaptationStepsComponent,
    PassengerChangeTimeVectorStepsComponent,
    StepsWidthFactorComponent,
    BoardingPlaceDensityOfPeopleFactorComponent,
    LocationWaysFactorComponent,
    DoorWidthAndPhysicalSeparationFactorComponent,
    MultiPurposeAreaViewComponent,
    AgeGenderCompareDialog,
    UsermanagementListChangeEmailComponent,
    SpecialFactorsComponent,
    LoaderComponentComponent,
    AddVariantComponent
  ]
})
export class AppModule { }